import styled from 'styled-components';

export const $SingleSlotSelector = styled('div')`
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
`;
